import React from 'react';
import Home from './components/Home';

function App() {
  return (
    <main id="main">
      <Home />
    </main>
  );
}

export default App;
